import heic2any from 'heic2any';
import {
  ImageCroppedEvent,
  OutputFormat,
  ImageCropperComponent as NgxImageCropperComponent,
} from 'ngx-image-cropper';
import { Component, Input, OnInit, Output, inject } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { ButtonTextSizes, SpinnerColor, Buttons, TextSizes, TextType } from '../../enums';
import { rotate } from '../../constants';
import { ICroppedImageData } from 'src/app/data/store/models/uploading-files.model';
import { TextComponent } from '../text/text.component';
import { SpinnerComponent } from '../spinner/spinner.component';

import { IonicModule } from '@ionic/angular';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss'],
  imports: [
    TextComponent,
    NgxImageCropperComponent,
    SpinnerComponent,
    IonicModule,
    ButtonComponent,
  ],
})
export class ImageCropperComponent implements OnInit {
  utils = inject(UtilsService);

  @Input() imageFile: File | undefined;

  @Input() imageFormat: OutputFormat = 'png';

  @Input() aspectRatio = 0;

  @Output() closed: () => void = () => {
    // no-op: обработка по умолчанию
  };

  @Output() changed: (data: ICroppedImageData) => void = () => {
    // no-op: обработка по умолчанию
  };

  isLoading = true;

  imageToCrop: File | undefined = undefined;

  croppedImage: ImageCroppedEvent | null = null;

  canvasRotation = 0;

  public readonly Buttons = Buttons;

  public readonly TextType = TextType;

  public readonly TextSizes = TextSizes;

  public readonly IconRotate = rotate;

  public readonly SpinnerColor = SpinnerColor;

  public readonly ButtonTextSizes = ButtonTextSizes;

  ngOnInit(): void {
    this.prepareImageToCrop();
  }

  rotate(direction: 'right' | 'left') {
    this.isLoading = true;
    const step = direction === 'right' ? 1 : -1;
    this.canvasRotation += step;
  }

  onComplete() {
    if (this.imageToCrop && this.croppedImage?.blob) {
      const croppedBlob = this.croppedImage.blob;
      const croppedFile = new File([croppedBlob], this.imageToCrop.name, {
        type: croppedBlob.type || this.imageToCrop.type,
      });

      this.changed({
        file: croppedFile,
        position: this.croppedImage.imagePosition,
      });
      this.closed();
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.isLoading = false;
    if (event.blob) {
      this.croppedImage = event;
    }
  }

  loadImageFailed() {
    this.utils.openNotification('Ошибка при загрузке изображения', true);
  }

  prepareImageToCrop() {
    if (!this.imageFile) {
      return;
    }

    let imageFormat: OutputFormat = 'png';
    const fileFormat = this.imageFile.name.split('.').pop()?.toLowerCase() || '';

    // Проверяем, поддерживается ли формат библиотекой ngx-image-cropper
    if (['png', 'jpeg', 'bmp', 'webp', 'ico'].includes(fileFormat)) {
      // imageFormat = imageFormat;
    } else if (fileFormat === 'jpg') {
      imageFormat = 'jpeg';
    }

    const mimeType = this.imageFile.type.toLowerCase() || fileFormat;

    // Если изображение heic или heif, то конвертируем в jpeg
    if (mimeType.includes('heic') || mimeType.includes('heif')) {
      heic2any({
        blob: this.imageFile,

        toType: 'image/jpeg',
      })
        .then((converted) => {
          imageFormat = 'jpeg';
          this.imageToCrop = new File([converted as Blob], 'converted.jpeg', {
            type: 'image/jpeg',
          });
        })
        .catch(async (error) => {
          // Ошибка может возникнуть тогда, когда мы руками конвертируем картинку в heic
          if (error.message.includes('Image is already browser readable')) {
            const hardMimeType = await this.utils.getMimeTypeViaFileReader(this.imageFile!);
            if (hardMimeType !== mimeType) {
              this.imageToCrop = new File([this.imageFile as Blob], this.imageFile!.name, {
                type: hardMimeType,
              });
              return;
            }
          }
          this.loadImageFailed();
        })
        .finally(() => {
          this.imageFormat = imageFormat;
        });
    } else {
      this.imageFormat = imageFormat;
      this.imageToCrop = this.imageFile;
    }
  }
}
